import { render, staticRenderFns } from "./CreateAccountWithCard.vue?vue&type=template&id=2b92a940&scoped=true&"
import script from "./CreateAccountWithCard.vue?vue&type=script&lang=js&"
export * from "./CreateAccountWithCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountWithCard.vue?vue&type=style&index=0&id=2b92a940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92a940",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCheckbox,VFlex,VForm,VLayout})
